// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Nm0xU","title":"styles_title__32rPr"};